import { Component, OnInit, Input } from '@angular/core';
import { isNull } from 'lodash-es';
import { ExpenseService } from '../../services/expense.service';
import { TimesheetService } from '../../services/timesheet.service';

@Component({
    selector: 'app-swipe',
    templateUrl: './swipe.component.html',
    styleUrls: ['./swipe.component.scss'],
    standalone: false
})
export class SwipeComponent implements OnInit {

  @Input() currentItemState: any;

  @Input() singleItem: any;
  @Input() itemIds: any;
  @Input() itemStateName: string;
  @Input() itemTypeName: any;
  @Input() slide: any;
  @Input() userFacing = false;
  showElement: boolean;

  constructor(private expenseService: ExpenseService, private timesheetService: TimesheetService) { }

  ngOnInit() {
    this.showElement = false;
    if(this.singleItem !==undefined){
      this.showElement = true;
    }
    else{
      if(this.itemIds.length > 2 ) {
        this.showElement = true;
      }
    }
  }

  filterTransitions(transitions: any[], direction): any[] {
    const res = transitions.filter(p => p.swipe_direction === direction);
    return res;
  }

  length(input: any[]): number {
    //console.log(input.length);
    return input.length;

  }

  swipe(
    args: {
      itemTypeName: string;
      singleItem: any;
      itemIds: any;
      itemStateName: string;
      slide: any;
      transition_name: any;
    }) {
      switch(this.itemTypeName){
      case 'expense':
        if (args.itemIds == null){
          this.expenseService.swipe(args.singleItem, args.transition_name, this.userFacing).subscribe(() => {
            args.slide.close();
          });
        }
        else{
          const idsJSON = JSON.parse(args.itemIds);
          this.expenseService.swipeMultiple(idsJSON, this.currentItemState.name,  args.transition_name).subscribe(() => {
            args.slide.close();
          });
        }
        break;

      case 'time':
        if (args.itemIds == null){
          this.timesheetService.swipe(args.singleItem, args.transition_name).subscribe(() => {
            args.slide.close();
          });
        }
        else{
          const idsJSON = JSON.parse(args.itemIds);
          this.timesheetService.swipeMultiple(idsJSON, this.currentItemState.name,  args.transition_name).subscribe(() => {
            args.slide.close();
          });
        }
        break;

      }
    }
}
